// extracted by mini-css-extract-plugin
export default {"header":"BDrugCard-module_header_eaf0a9f3","footer":"BDrugCard-module_footer_dc3c423d"};